import { TrustEyeOffIcon, TrustGlobeIcon, TrustLockIcon, TrustShieldIcon, TrustSparkIcon } from './icons';

/* Trust badges row on the landing page. Extracted from Landing.tsx (Phase 4). */
export function TrustBar() {
  const items = [
    { icon: <TrustShieldIcon />, label: 'Sans publicité' },
    { icon: <TrustGlobeIcon />, label: 'Données en Europe' },
    { icon: <TrustLockIcon />, label: 'Conforme RGPD' },
    { icon: <TrustSparkIcon />, label: 'IA sécurisée' },
    { icon: <TrustEyeOffIcon />, label: 'Pas de tracking' },
  ];
  return (
    <div className="trust-bar">
      <div className="landing-container trust-inner">
        {items.map((it, i) => (
          <div key={it.label} className="trust-item" data-animate="" data-delay={String(i * 80)}>
            {it.icon}
            <span>{it.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
